import { render, staticRenderFns } from "./ApprovalRequestManager.vue?vue&type=template&id=ee78aaa8"
import script from "./ApprovalRequestManager.vue?vue&type=script&lang=js"
export * from "./ApprovalRequestManager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports